import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Core } from "@faire/design-tokens";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Storage } from "@faire/web--source/common/Storage";
import { Button } from "@faire/web--source/slate/Button";
import Checkbox from "@faire/web--source/slate/Checkbox";
import { TextArea } from "@faire/web--source/slate/Input/TextArea";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackHelpCenterComprehensiveChatCsatSubmit } from "@faire/web-api--source/events/helpCenter/submit/comprehensiveChatCsat";
import { QueryParameters as chatQueryParams } from "@faire/web-api--source/routes/www/support/self-serve/chat-csat";
import React from "react";
import styled from "styled-components";
import { FAIRE_CHAT_CSAT_FEEDBACK_SUBMITTED_STORAGE_KEY } from "../consts";
import { ChatCsatProvider } from "../hooks/ChatCsatContextStore";
import { initQuestions } from "../questions";
import { chosenReasons } from "../utils";
import { ChatCsatCollected } from "./ChatCsatCollected";
import { ChatCsatWrapper } from "./ChatCsatWrapper";
import { CsatTitle } from "./CsatTitle";
var EMPTY_AGENT_NAME = "";
export var ChatCsat = function ChatCsat() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useQueryParams = useQueryParams(chatQueryParams.parse),
    ticket_id = _useQueryParams.ticket_id;
  var surveyType = ticket_id ? "chat" : "email";
  var _React$useState = React.useState(function () {
      return initQuestions(strictLocalize, surveyType);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    questions = _React$useState2[0],
    setQuestions = _React$useState2[1];
  var _React$useState3 = React.useState(""),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    feedback = _React$useState4[0],
    setFeedback = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    feedbackCollected = _React$useState6[0],
    setFeedbackCollected = _React$useState6[1];
  var retailerToken = getRetailerToken();
  var brandToken = getBrandToken();
  var submitDisabled = function submitDisabled() {
    var allUnchecked = Object.keys(questions).every(function (key) {
      return !questions[key].checked;
    });
    return allUnchecked && feedback.length === 0;
  };
  var chatCsatHasBeenSubmitted = Storage.local.getItem(FAIRE_CHAT_CSAT_FEEDBACK_SUBMITTED_STORAGE_KEY) === "true" && surveyType === "chat";
  var handleCheckboxChange = function handleCheckboxChange(key) {
    setQuestions(_objectSpread(_objectSpread({}, questions), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, questions[key]), {}, {
      checked: !questions[key].checked
    }))));
  };
  var handleFeedbackChange = function handleFeedbackChange(e) {
    e.preventDefault();
    setFeedback(e.target.value);
  };
  var handleSubmitClick = function handleSubmitClick() {
    // PETE event: https://www.faire.com/pete/event/help_center-comprehensive_chat_csat-submit
    trackHelpCenterComprehensiveChatCsatSubmit(brandToken !== null && brandToken !== void 0 ? brandToken : "", retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", feedback, chosenReasons(questions), ticket_id !== null && ticket_id !== void 0 ? ticket_id : "", EMPTY_AGENT_NAME);
    setFeedbackCollected(true);
    if (surveyType === "chat") {
      Storage.local.setItem(FAIRE_CHAT_CSAT_FEEDBACK_SUBMITTED_STORAGE_KEY, "true");
    }
  };
  if (feedbackCollected || chatCsatHasBeenSubmitted) {
    return /*#__PURE__*/React.createElement(ChatCsatProvider, {
      value: {
        surveyType: surveyType
      }
    }, /*#__PURE__*/React.createElement(ChatCsatWrapper, null, /*#__PURE__*/React.createElement(ChatCsatCollected, null)));
  }
  return /*#__PURE__*/React.createElement(ChatCsatProvider, {
    value: {
      surveyType: surveyType
    }
  }, /*#__PURE__*/React.createElement(ChatCsatWrapper, null, /*#__PURE__*/React.createElement(CsatTitle, null), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), Object.keys(questions).map(function (key) {
    var question = questions[key];
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, /*#__PURE__*/React.createElement(Checkbox, _objectSpread(_objectSpread({}, question), {}, {
      onChange: function onChange() {
        return handleCheckboxChange(key);
      },
      "data-test-id": "checkbox-".concat(key)
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "2x"
    }));
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "wsd+cF",
    defaultMessage: "Please provide any other feedback (optional)"
  })), /*#__PURE__*/React.createElement(FeedbackTextArea, {
    value: feedback,
    onChange: handleFeedbackChange
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "labelSansRegular",
    color: Core.text.subdued
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "OBnSW8",
    defaultMessage: "Note: We\u2019re unable to reply directly to any comments provided here. Please contact us through the Help Center for further assistance."
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(SubmitButton, {
    onClick: handleSubmitClick,
    disabled: submitDisabled()
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "n9zPxJ",
    defaultMessage: "Submit"
  }))));
};
var SubmitButton = styled(Button).withConfig({
  displayName: "ChatCsat__SubmitButton"
})(["width:300px;", "{width:100%;}"], responsiveMediaQueries.mobile);
var FeedbackTextArea = styled(TextArea).withConfig({
  displayName: "ChatCsat__FeedbackTextArea"
})(["height:100px;"]);